// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.video-time-indicators {
    position: relative;
    height: 3rem;
    overflow-x: visible;
    background-color: #202020;
}

    div.video-time-indicators .tick-container {
        position: absolute;
        transform: translateX(-50%);
        height: 100%;
    }

    div.video-time-indicators .tick-mark {
        position: absolute;
        top: 0;
        width: 1px;
        height: 1rem;
        background-color: lightgray;
    }

    div.video-time-indicators .tick-label {
        position: absolute;
        top: 1.2rem;
        font-size: 0.75rem;
        color: lightgray;
        white-space: nowrap;
        transform: translateX(-50%);
    }

    div.video-time-indicators .minor-tick-mark {
        position: absolute;
        top: 0;
        width: 1px;
        height: 0.5rem;
        background-color: lightgray;
        opacity: 0.5;
        transform: translateX(-50%);
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/VideoThumbnailTicks.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;IAEI;QACI,kBAAkB;QAClB,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,UAAU;QACV,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,UAAU;QACV,cAAc;QACd,2BAA2B;QAC3B,YAAY;QACZ,2BAA2B;IAC/B","sourcesContent":["div.video-time-indicators {\r\n    position: relative;\r\n    height: 3rem;\r\n    overflow-x: visible;\r\n    background-color: #202020;\r\n}\r\n\r\n    div.video-time-indicators .tick-container {\r\n        position: absolute;\r\n        transform: translateX(-50%);\r\n        height: 100%;\r\n    }\r\n\r\n    div.video-time-indicators .tick-mark {\r\n        position: absolute;\r\n        top: 0;\r\n        width: 1px;\r\n        height: 1rem;\r\n        background-color: lightgray;\r\n    }\r\n\r\n    div.video-time-indicators .tick-label {\r\n        position: absolute;\r\n        top: 1.2rem;\r\n        font-size: 0.75rem;\r\n        color: lightgray;\r\n        white-space: nowrap;\r\n        transform: translateX(-50%);\r\n    }\r\n\r\n    div.video-time-indicators .minor-tick-mark {\r\n        position: absolute;\r\n        top: 0;\r\n        width: 1px;\r\n        height: 0.5rem;\r\n        background-color: lightgray;\r\n        opacity: 0.5;\r\n        transform: translateX(-50%);\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
